import { useEffect, useRef, useState } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { useLocation } from 'react-router-dom'
import PdfViewer from './PdfViewer'

export default function ViewerArea() {
  const { authState, oktaAuth } = useOktaAuth()
  const location = useLocation()
  const started = useRef(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!authState || authState.isAuthenticated || started.current) return
    started.current = true
    // Do not force prompt=login: a top-level redirect reuses Okta's SSO cookie
    // without relying on third-party cookies or a silent authentication iframe.
    oktaAuth.signInWithRedirect({ originalUri: location.pathname + location.search })
      .catch(() => setError('Unable to connect to Okta. Please reopen this report link.'))
  }, [authState, oktaAuth, location.pathname, location.search])

  if (error) return <p className='p-8' role='alert'>{error}</p>
  if (!authState?.isAuthenticated) return <p className='p-8' role='status'>Checking your Okta session…</p>
  return <PdfViewer />
}
